import { render } from "./PowerupsGrid.vue?vue&type=template&id=f0f3f1dc&scoped=true"
import script from "./PowerupsGrid.vue?vue&type=script&lang=js"
export * from "./PowerupsGrid.vue?vue&type=script&lang=js"

import "./PowerupsGrid.vue?vue&type=style&index=0&id=f0f3f1dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f3f1dc"]])

export default __exports__